<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <div class="flex-sub margin-right">
          <div class="flex align-center justify-between">
            <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
              <span>姓<i style="padding-left: 14px;"></i>名：</span>
              <el-input v-model="name" placeholder="请输入姓名" class="flex-sub"></el-input>
            </div>
            <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
              <span>手机号：</span>
              <el-input v-model="phone" placeholder="请输入手机号" class="flex-sub"></el-input>
            </div>
            <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
              <span>户籍地：</span>
              <el-input v-model="register" placeholder="请输入户籍地" class="flex-sub"></el-input>
            </div>
            <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
              <span>身份证：</span>
              <el-input v-model="idcard" placeholder="请输入身份证" class="flex-sub"></el-input>
            </div>
          </div>
          <div class="flex align-center justify-between margin-bottom-xs">
            <div class="flex align-center margin-right-sm basis-smf">
              <span>性<i style="padding-left: 14px;"></i>别：</span>
              <el-select v-model="sex" placeholder="请选择" class="flex-sub">
                <el-option v-for="item in sexList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="flex align-center margin-right-sm basis-smf">
              <span>户口性质：</span>
              <el-select v-model="nature" placeholder="请选择" class="flex-sub">
                <el-option v-for="item in natureList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="flex align-center margin-right-sm basis-smf">
              <span>与户主关系：</span>
              <el-select v-model="relation" placeholder="请选择" class="flex-sub">
                <el-option v-for="item in relationList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="flex align-center margin-right-sm basis-smf">
              <span>提醒类型：</span>
              <el-select v-model="tips" placeholder="请选择" class="flex-sub">
                <el-option v-for="item in tipsList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <fiveLevel @upFive="upFive" :sproject="project" :scommunity="community" />
        </div>
        <el-button type="primary" @click="hanldSearch">搜索</el-button>
      </div>

      <div class="flex align-center justify-between margin-tb-sm">
        <div>
          共{{ total }}条数据
        </div>
        <div>
          <el-button v-if="[3, 6].includes(user.power)" size="small" type="primary" @click="residentDialog = true">新增居民
          </el-button>
          <el-link :href="upUrl + '/uploads/demo.xls'" target="_blank" v-if="[3, 6].includes(user.power)"
            class="margin-lr-xs">
            <el-button size="small" type="warning">导入模版下载
            </el-button>
          </el-link>

          <el-button v-if="[3, 6].includes(user.power)" size="small" type="warning" @click="importDialog = true">导入居民
          </el-button>
          <el-button v-if="[3, 5].includes(user.power)" size="small" type="warning" @click="exportJuMinList">导出居民信息
          </el-button>
        </div>
      </div>

      <el-table :data="residentList" header-row-class-name="table-header" row-class-name="table-row" alig="center"
        border style="width: 100%">
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
        <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
        <el-table-column label="楼门户">
          <template slot-scope="scope">
            <div>
              {{ scope.row.building_name }}-{{ scope.row.element_name }}-{{ scope.row.room_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="联系人" prop="lianxiren"></el-table-column>
        <el-table-column label="居民姓名" prop="name"></el-table-column>
        <el-table-column label="性别" prop="sex">
          <template slot-scope="scope">
            <div>
              {{ scope.row.sex | sex }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="生日" prop="birthCN"></el-table-column>
        <!--        <el-table-column label="年龄" prop="age"></el-table-column>-->
        <el-table-column label="居民状态">
          <template slot-scope="scope">
            <div>
              {{ scope.row.status | status }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="健康状态">
          <template slot-scope="scope">
            <div>
              {{ scope.row.health | health }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="服务次数" prop="service_num"></el-table-column>
        <!-- <el-table-column label="服务认证" width="150">
          <template slot-scope="scope">
              <div class="flex align-center justify-between">
                <el-switch
                  style="display: block"
                  v-model="scope.row.is_old"
                  active-color="#13ce66"
                  inactive-color="#999999"
                  @change="setOld(scope.row.id)"
                  >
                </el-switch>
                  <el-button
                      v-if="scope.row.is_old && scope.row.is_watch === 0"
                      size="small"
                      type="danger"
                      @click="editItemWatch(scope.row.id,scope.row.name)"
                  >绑定手表
                  </el-button>
                  <el-button
                      v-if="scope.row.is_old && scope.row.is_watch === 1"
                      size="small"
                      type="warning"
                      @click="deleteItemWatch(scope.row.id)"
                  >解绑手表
                  </el-button>
              </div>
          </template>
        </el-table-column>
        <el-table-column label="标签" width="100px">
          <template slot-scope="scope">
            <div>
              {{ scope.row.tags_name}}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button v-if="[3, 6].includes(user.power)" size="small" type="primary" @click="editItem(scope.row)">编辑
              </el-button>
              <el-button size="small" type="primary" @click="showItem(scope.row)">查看
              </el-button>
              <el-button v-if="[3, 6].includes(user.power)" size="small" type="primary"
                @click="deleteItem(scope.row.id)">删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="residentList.length > 0" class="page-all" background @current-change="getResidentList"
        :current-page.sync="page" :page-size="limit" layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <residentDialog :setId="setId" :setItem="setItem" :residentDialog="residentDialog" @cancelDialog="cancelDialog" />
    <residentDetail :setItem="setItem" :residentDetail="residentDetail" @cancelDialog="cancelDialog" />
    <importDialog :importDialog="importDialog" @cancelDialog="cancelDialog" />
  </div>
</template>

<script>

import { sex, nature, relation, live, health, optionList, filesCN, tipsList } from "@/utils/utils";
import residentDialog from "@/views/pages/dialog/residentDialog";
import residentDetail from "@/views/pages/dialog/residentDetail";
import importDialog from "@/views/pages/dialog/importDialog";
import fiveLevel from '@/components/five-level'
import { juMinDel, juMinList, setOld } from "@/api/resident";
import { ONLINEHOST, QAHOST } from "@/config";
import { exportJuMinList } from "@/api/exportExcel";
import { bdingEquipment, delEquipment } from "@/api/service";

export default {
  name: "resident-data",
  data() {
    return {
      upUrl: process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST,
      sexList: optionList(true, sex),
      natureList: optionList(true, nature),
      relationList: optionList(true, relation),
      tipsList: optionList(true, tipsList),
      name: '',
      phone: '',
      register: '',
      idcard: '',
      sex: 0,
      nature: 0,
      relation: 0,
      tips: 0,
      project: 0,
      community: 0,
      building: 0,
      unit: 0,
      room: 0,
      page: 1,
      limit: 10,
      total: 0,
      residentList: [],
      setId: 0,
      setItem: {},
      residentDialog: false,
      residentDetail: false,
      importDialog: false,
      tagDialog: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", this.$route.path, "居民数据", false);
    if (this.$route.query.tips) this.tips = Number(this.$route.query.tips)
    if (this.$route.query.project) this.project = Number(this.$route.query.project)
    if (this.$route.query.community) this.community = Number(this.$route.query.community)
    this.getResidentList()
  },
  components: {
    fiveLevel,
    residentDialog,
    residentDetail,
    importDialog
  },
  methods: {
    //  设置标签
    setTag(obj) {
      this.setItem = obj;
      this.setId = obj.id;
      this.tagDialog = true;
    },
    //  居民导出
    async exportJuMinList() {
      let _state = await exportJuMinList(
        this.name,
        this.phone,
        this.register,
        this.idcard,
        this.project,
        this.community,
        this.building,
        this.unit,
        this.room,
        this.sex,
        this.nature,
        this.relation,
        this.tips,
      )
      let blob = _state.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', '居民数据.csv');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    //  居民信息编辑后回调
    cancelDialog(val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.residentDialog = false;
        this.residentDetail = false;
        this.importDialog = false;
        this.tagDialog = false;
        this.getResidentList();
      } else {
        this.setId = 0;
        this.setItem = {};
        this.residentDialog = false;
        this.residentDetail = false;
        this.importDialog = false;
        this.tagDialog = false;
      }
    },
    //  绑定手表
    editItemWatch(id, name) {
      this.$prompt('请输入手表的IMEI', '手表绑定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        if (!value) this.$message.error('未输入手表的IMEI')
        this.sureBindWatch(id, value, name)
      })
    },
    async sureBindWatch(id, value, name) {
      let _state = await bdingEquipment(id, value, name);
      if (this.residentList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getResidentList();
      this.$message.success(_state.info);
    },
    //  解绑手表
    deleteItemWatch(id) {
      this.$confirm('您确定要解绑该居民信息吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDeleteWatch(id);
      });
    },
    async sureDeleteWatch(id) {
      let _state = await delEquipment(id);
      if (this.residentList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getResidentList();
      this.$message.success(_state.info);
    },

    //  删除
    deleteItem(id) {
      this.$confirm('您确定要删除该居民信息吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await juMinDel(id);
      if (this.residentList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getResidentList();
      this.$message.success(_state.info);
    },
    //  查看
    showItem(obj) {
      this.setItem = obj;
      this.residentDetail = true;
    },
    //  编辑
    editItem(obj) {
      this.setItem = obj;
      this.setId = obj.id;
      this.residentDialog = true;
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.getResidentList()
    },
    async setOld(id) {
      await setOld(id)
      this.getResidentList()
    },
    //  获取居民列表
    async getResidentList() {
      let _data = await juMinList(
        this.name,
        this.phone,
        this.register,
        this.idcard,
        this.project,
        this.community,
        this.building,
        this.unit,
        this.room,
        this.sex,
        this.nature,
        this.relation,
        this.tips,
        this.page,
        this.limit,
      )
      if (_data.status === 200) {
        _data.data.map(item => {
          item.is_old = item.is_old ? true : false
          item.oldText = item.is_old ? '已认证' : '未认证'
        })
        this.residentList = _data.data
        this.total = _data.total_number
      } else {
        this.$message.error(_data.info)
        this.residentList = []
        this.total = 0
      }

    },
    //  同步更新五级联动
    upFive(val) {
      this.project = val.project
      this.community = val.community
      this.building = val.building
      this.unit = val.unit
      this.room = val.room
    }
  },
  filters: {
    status(val) {
      return filesCN(val, live)
    },
    sex(val) {
      return filesCN(val, sex)
    },
    health(val) {
      return filesCN(Number(val), health)
    }
  },
  watch: {},
}
</script>

<style scoped lang="scss"></style>
